import { IPatient, IProvider } from './chat.type'
import { INote } from './note.type'

export interface IContact {
  contact_id?: string
  clinic_id: string
  patient_id?: string
  provider_id?: string
  title?: string
  first_name: string
  middle_name?: string
  preferred_name?: string
  last_name: string
  address: string
  city: string
  state: string
  zip: string
  cellphone: string
  email: string
  home_phone?: string
  work_phone?: string
  fax_number?: string
  photo?: string
  notes?: string
  is_subscribed?: boolean
  is_hidden?: boolean
  preferred_call_method?: string
  created_by?: string
  updated_by?: string
  date_time_created_at?: string
  date_time_updated_at?: string

  calls?: [
    {
      tag?: string
      notes?: string
    },
  ]

  patient?: IPatient

  provider?: IProvider

  contact_groups?: IContactGroup[]

  contact_group_participant?: {
    contact_group_participant_id?: string
    date_time_created_at: string
  }

  contact_note?: INote[]
}

export interface IContactGroupParticipant {
  contact_group_participant_id?: string
  contact_group_id: string
  contact_id: string
  created_by: string
  updated_by: string
  date_time_created_at?: string
  date_time_updated_at?: string
}

export interface IContactGroup {
  contact_group_id?: string
  clinic_id: string
  group_name: string
  channel: string
  description?: string
  is_hidden?: boolean
  created_by: string
  updated_by: string
  date_time_created_at?: string
  date_time_updated_at?: string

  contacts?: IContact[]
}

export const ContactGroupChannel = [
  {
    key: 'sms',
    value: 'SMS',
  },
  {
    key: 'messenger',
    value: 'Messenger',
  },
  {
    key: 'instagram',
    value: 'Instagram',
  },
]
